import { OnChangeValue } from 'react-select';

import { SearchIcon } from '../../../../assets/images/icons';
import { FormMode } from '../../../../common/constants/enums';
import {
  draftOptions,
  DraftOptionType,
} from '../../../../common/constants/select-options';
import { IFetchBestPagesOptions } from '../../../../common/interfaces/pages-api';
import { Input } from '../../../../common/ui/Input';
import { Select } from '../../../../common/ui/select';
import { PageType } from '../../../../context/page-form-context';
import { TSetFilter, useAppSelector } from '../../../../hooks';
import { AuthorSelect } from '../../../common/author-select';
import { BrandInput } from '../brand-input';
import { DomainSelect } from '../domain-select';
import { PublisherSelect } from '../publisher-select';
import styles from './pages-filter.module.scss';

export type PageTypeOption = 'single' | 'multiple';

export interface IPagesFilter {
  filter: Partial<IFetchBestPagesOptions> & { pageType?: PageTypeOption; slug?: string };
  updateFilter: TSetFilter<Omit<IFetchBestPagesOptions, 'attribution'> & { pageType?: PageTypeOption; slug?: string }>;
  statusOptions: DraftOptionType[];
}

const PagesFilter = ({ filter, statusOptions, updateFilter }: IPagesFilter) => {
  const { pageStatusesList } = useAppSelector(({ pages }) => pages);

  const pageStatusHandler = (option: OnChangeValue<DraftOptionType, false>) => {
    if (option) {
      updateFilter({ status: option.value });
    } else {
      updateFilter({ status: null });
    }
  };

  const isMultiple = filter.pageType === 'multiple';

  const pageTypeOptions = [
    { label: 'Single Marketplace (v1)', value: 'single' as PageTypeOption },
    { label: 'Multiple Marketplace (v2)', value: 'multiple' as PageTypeOption },
  ];

  return (
    <div className={styles.pages_filter}>
      <div className={styles.filter_elem_wrapper}>
        <Select
          onChange={(option) => updateFilter({ pageType: option.value as PageTypeOption })}
          options={pageTypeOptions}
          placeholder="Makretplace"
          value={pageTypeOptions.find((o) => o.value === (filter.pageType ?? 'single'))}
        />
      </div>
      <div className={styles.filter_elem_wrapper}>
        <PublisherSelect formMode={FormMode.SEARCH} updateFilter={updateFilter} />
      </div>
      {/* <div className={styles.filter_elem_wrapper}> */}
      {/*   <Select */}
      {/*     onChange={(option) => { */}
      {/*       updateFilter({ marketplace: option.value }); */}
      {/*     }} */}
      {/*     options={marketplaceOptions} */}
      {/*     placeholder="Marketplace ..." */}
      {/*     value={marketplaceOptions.find((elem) => elem.value === filter.marketplace)} */}
      {/*   /> */}
      {/* </div> */}
      {/* <div className={styles.filter_elem_wrapper}> */}
      {/*   <Select */}
      {/*     onChange={(option) => { */}
      {/*       updateFilter({ layout: option.value as PageType }); */}
      {/*     }} */}
      {/*     options={pageLayoutOptions} */}
      {/*     placeholder="Layout ..." */}
      {/*     value={pageLayoutOptions.find((elem) => elem.value === filter.layout)} */}
      {/*   /> */}
      {/* </div> */}
      <div className={styles.filter_elem_wrapper}>
        {isMultiple ? (
          <Input
            fullWidth
            iconBefore={<SearchIcon />}
            name="slug"
            onChange={({ target: { value } }) => updateFilter({ slug: value })}
            placeholder="Search ..."
            value={filter.slug ?? ''}
            variant="secondary"
          />
        ) : (
          <Input
            fullWidth
            iconBefore={<SearchIcon />}
            name="keyword"
            onChange={({ target: { value } }) => updateFilter({ keyword: value })}
            placeholder="Keyword ..."
            value={filter.keyword}
            variant="secondary"
          />
        )}
      </div>
      {!isMultiple && filter.layout === PageType.Brands && (
        <div className={styles.filter_elem_wrapper}>
          <BrandInput
            brandName={filter?.brand}
            formMode={FormMode.SEARCH}
            placeholder="Brand ..."
            updateFilter={updateFilter}
          />
        </div>
      )}
      <div className={styles.filter_elem_wrapper}>
        <Select
          isClearable
          isLoading={pageStatusesList.loading}
          onChange={pageStatusHandler}
          options={statusOptions}
          placeholder="Google Ads Status ..."
          value={statusOptions.filter((elem) => elem.value === filter.status)}
        />
      </div>
      {!isMultiple && (
        <div className={styles.filter_elem_wrapper}>
          <Select
            closeMenuOnSelect={false}
            isClearable
            isMulti
            onChange={(newValue) => {
              if (newValue) {
                updateFilter({ draft: newValue.map((option) => option.value) });
              }
            }}
            options={draftOptions}
            placeholder="Flagged Drafts ..."
            value={draftOptions.filter((option) =>
              filter.draft?.some((elem) => elem === option.value),)}
          />
        </div>
      )}
      {!isMultiple && filter.domain !== 'bestbuyguidebook.com' && (
        <div className={styles.filter_elem_wrapper}>
          <AuthorSelect
            onOptionClick={(id) => updateFilter({ author: id })}
            placeholder="Author ..."
          />
        </div>
      )}
      {!isMultiple && (
        <div className={styles.filter_elem_wrapper}>
          {(!filter.publisher || filter.publisher === 0) && (
            <DomainSelect
              initialValue={filter.domain}
              onChange={(option) => {
                const filterPayload: Partial<Omit<IFetchBestPagesOptions, 'attribution'>> = {
                  domain: option?.label,
                };
                if (option?.label === 'bestbuyguidebook.com') {
                  filterPayload.author = null;
                }
                updateFilter(filterPayload);
              }}
              placeholder="Domain ..."
            />
          )}
        </div>
      )}
    </div>
  );
};

export { PagesFilter };
